import "../../assets/css/SalesBill.css";
import ApiUrl from "./../Environment/ApiUrl";
import axios from "axios";
import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const ChitSmallbill = () => {
  const { id } = useParams();
  const [chitData, setChitData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (id) fetchChitData();
  }, [id]);

  const fetchChitData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${ApiUrl}/Api/chit_list.php/${id}`);
      const allData = response.data.data || [];
      const found = allData.find(item => String(item.id) === String(id)) || allData[0];
      if (found) {
        setChitData(found);
      } else {
        setError(`No chit data found for ID: ${id}`);
      }
    } catch {
      setError("Failed to fetch chit data");
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;
    const options = { year: "numeric", month: "short", day: "2-digit" };
    return date.toLocaleDateString("en-US", options);
  };

  const numberToWords = (num) => {
    const ones = ["","One","Two","Three","Four","Five","Six","Seven","Eight","Nine",
      "Ten","Eleven","Twelve","Thirteen","Fourteen","Fifteen","Sixteen",
      "Seventeen","Eighteen","Nineteen"];
    const tens = ["","","Twenty","Thirty","Forty","Fifty","Sixty","Seventy","Eighty","Ninety"];
    if (num === 0) return "Zero";
    const convert = (n) => {
      if (n === 0) return "";
      if (n < 20) return ones[n];
      if (n < 100) return tens[Math.floor(n/10)] + (n%10 ? " "+ones[n%10] : "");
      if (n < 1000) return ones[Math.floor(n/100)]+" Hundred "+(n%100 ? convert(n%100) : "");
      if (n < 100000) return convert(Math.floor(n/1000))+" Thousand "+(n%1000 ? convert(n%1000) : "");
      if (n < 10000000) return convert(Math.floor(n/100000))+" Lakh "+(n%100000 ? convert(n%100000) : "");
      return convert(Math.floor(n/10000000))+" Crore "+(n%10000000 ? convert(n%10000000) : "");
    };
    return convert(Math.floor(num)).trim() + " Only";
  };

  if (loading) return <div style={{textAlign:"center",padding:"40px"}}>Loading chit data...</div>;
  if (error) return <div style={{textAlign:"center",padding:"40px",color:"red"}}>{error}</div>;
  if (!chitData) return <div style={{textAlign:"center",padding:"40px"}}>No data available</div>;

  const payments = chitData.payment_history || [];

  // Split by payment type
  const totalCashPaid = payments
    .filter(p => (p.payment_type || "").toLowerCase() === "cash")
    .reduce((s, p) => s + parseFloat(p.paid || 0), 0);
  const totalGoldPaid = payments
    .filter(p => (p.payment_type || "").toLowerCase() === "gold")
    .reduce((s, p) => s + parseFloat(p.paid || 0), 0);
  const totalPaid = payments.reduce((s, p) => s + parseFloat(p.paid || 0), 0);

  const chitAmount = parseFloat(chitData.amount || 0);
  const duration = parseInt(chitData.duration || 1);
  const expectedTotal = chitAmount * duration;
  const balance = Math.max(0, expectedTotal - totalPaid);

  const returnType = chitData.return_type || "";
  const goldWeight = chitData.gold_weight || "";
  const returnAmount = parseFloat(chitData.excess_amount || 0);

  let runningBal = expectedTotal;

  return (
    <div className="bill-container">
      <button className="print-btn no-print" onClick={() => window.print()}>
        Print Bill
      </button>
      <button className="cancel-btn no-print" onClick={() => navigate("/chit/chit-list")}>
        Cancel
      </button>

      {/* Header */}
      <div className="header-section row align-items-center">
        <div className="col-3 text-start">
          <img
            src={require("../../assets/images/Final logo c.png")}
            alt="TIRUPUR Logo"
            className="img-fluid"
            style={{ maxHeight: "80px" }}
          />
        </div>
        <div className="col-6 company-info text-center">
          <h4 className="mb-1">TIRUPUR JEWELLERY</h4>
          <p className="mb-0">3/1, Thandan St, Shevapet, Salem, Tamil Nadu 636002</p>
          <p className="mb-0">Ph: 04272233807</p>
        </div>
        <div className="col-3 company-info">
          <h4 className="text-dark">CHIT RECEIPT</h4>
          {chitData.status === "Close" && (
            <p style={{color:"#155724",fontWeight:"bold",fontSize:"10px"}}>● CLOSED</p>
          )}
        </div>
      </div>

      <hr className="divider" />

      {/* Customer + Chit Details */}
      <div className="details-section">
        <div className="customer-info">
          <div className="customer-details">
            <p><strong>{chitData.name}</strong></p>
            <p>{chitData.address}</p>
            <p>Cell: {chitData.mobile}</p>
            {chitData.aadhar_no && <p>Aadhar: {chitData.aadhar_no}</p>}
            <p>Customer ID: {chitData.customer_id}</p>
          </div>
        </div>
        <div className="invoice-info">
          <div className="info-row"><span>Chit ID</span><span>: {chitData.chit_id}</span></div>
          <div className="info-row"><span>Bill Date</span><span>: {formatDate(new Date().toISOString())}</span></div>
          <div className="info-row"><span>Start Date</span><span>: {formatDate(chitData.start_date)}</span></div>
          <div className="info-row"><span>End Date</span><span>: {formatDate(chitData.end_date)}</span></div>
          <div className="info-row"><span>Duration</span><span>: {chitData.duration} Months</span></div>
          <div className="info-row"><span>Status</span><span>: {chitData.status}</span></div>
          {chitData.manager_name && <div className="info-row"><span>Manager</span><span>: {chitData.manager_name}</span></div>}
          {chitData.staff && <div className="info-row"><span>Staff</span><span>: {chitData.staff}</span></div>}
        </div>
      </div>

      {/* Payment Table */}
      <div className="table-section">
        <table className="bill-table">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Date</th>
              <th>Payment Type</th>
              <th>Amount (₹)</th>
              <th>Balance (₹)</th>
            </tr>
          </thead>
          <tbody>
            {payments.length === 0 ? (
              <tr><td colSpan="5">No payments recorded</td></tr>
            ) : (
              payments.map((p, i) => {
                runningBal -= parseFloat(p.paid || 0);
                const dispBal = runningBal < 0 ? 0 : runningBal;
                return (
                  <tr key={i}>
                    <td>{i + 1}</td>
                    <td>{formatDate(p.payment_date)}</td>
                    <td>{p.payment_type || "-"}</td>
                    <td>₹{parseFloat(p.paid || 0).toFixed(2)}</td>
                    <td>{dispBal.toFixed(2)}</td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>

      {/* Totals + Words */}
      <div className="details-section">
        <div className="customer-info">
          <div className="amount-in-words">
            <p>Rupees: {totalPaid > 0 ? numberToWords(totalPaid) : "Zero"}</p>
          </div>
          <p>*Terms &amp; Conditions</p>
          <p className="paragraph-cont">
            Chit amount must be paid monthly on time.<br />
            Interest may apply on late payments.<br />
            Return of amount as cash or gold upon closure.
          </p>
        </div>
        <div className="invoice-info">
          <div className="totals-section">
            <div className="totals-grid">
              <div className="total-row">
                <span>Monthly Amount</span>
                <span>₹{chitAmount.toFixed(2)}</span>
              </div>
              <div className="total-row">
                <span>Duration</span>
                <span>{duration} months</span>
              </div>
              <div className="total-row">
                <span>Total Expected</span>
                <span>₹{expectedTotal.toFixed(2)}</span>
              </div>
              {totalCashPaid > 0 && (
                <div className="total-row">
                  <span>Cash Paid</span>
                  <span>₹{totalCashPaid.toFixed(2)}</span>
                </div>
              )}
              {totalGoldPaid > 0 && (
                <div className="total-row">
                  <span>Gold Paid</span>
                  <span>₹{totalGoldPaid.toFixed(2)}</span>
                </div>
              )}
              <div className="total-row highlight">
                <span>Total Paid</span>
                <span>₹{totalPaid.toFixed(2)}</span>
              </div>
              {balance > 0 && (
                <div className="total-row">
                  <span>Balance Due</span>
                  <span>₹{balance.toFixed(2)}</span>
                </div>
              )}
              {chitData.status === "Close" && returnType && (
                <>
                  {returnType === "cash" && (
                    <div className="total-row" style={{color:"#155724",fontWeight:"bold"}}>
                      <span>Cash Returned</span>
                      <span>₹{returnAmount > 0 ? returnAmount.toFixed(2) : totalPaid.toFixed(2)}</span>
                    </div>
                  )}
                  {returnType === "gold" && goldWeight && (
                    <div className="total-row" style={{color:"#856404",fontWeight:"bold"}}>
                      <span>Gold Returned</span>
                      <span>{goldWeight}g</span>
                    </div>
                  )}
                </>
              )}
              <div className="total-row">
                <span>Chit Status</span>
                <span>{chitData.status}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <hr className="divider" />

      {/* Footer */}
      <div className="footer-section">
        <div className="signatures">
          <div className="customer-sign">
            <p>Signature of the Customer</p>
          </div>
          <div>
            <p className="footer-notes">--- Thank You ---</p>
            <div className="alaan">
              <p>Developed by Aalan Tech Soft - Salem</p>
            </div>
          </div>
          <div className="company-sign">
            <p>FOR TIRUPUR JEWELLERY</p>
            <p>Authorized Signature</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChitSmallbill;